export default function RiskManagement() {
  const risks = [
    {
      number: '1',
      title: '事故への備え：万全の「車両保険」を付帯',
      description: '万が一、利用者が事故を起こしても、投資家様が修繕費用を負担することはありません。充実した車両保険によって資産価値は守られ、月々の買取金支払いが止まるリスクを排除しています。'
    },
    {
      number: '2',
      title: '悪意ある不正への対策：「GPS監視」と「警察連携」',
      description: '車両には高性能GPSを搭載。万が一、意図的にGPSが外されたり、異常な通信遮断が発生したりした場合は、即座にシステムがアラートを発信します。リトラストは警察と緊密に連携しており、盗難や持ち逃げに対しても法的・物理的に即応できる体制を整えています。'
    },
    {
      number: '3',
      title: '逃亡・遠隔移動の阻止：「即時連絡」と「即時回収」',
      description: '車両の移動状況はリアルタイムでモニタリングされています。契約外の遠隔移動や支払いの滞納の兆候が見られた場合、即座に利用者にコンタクトをとり、事態が改善されない場合は、専門チームが車両をスピーディーに回収し、別の利用者へ再リースを行います。'
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-[#0F1B2E] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23D4AF37' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="w-20 h-0.5 bg-[#D4AF37] mx-auto mb-8"></div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight font-serif">
            「投資」を「確実な収益」に変える。<br />
            あらゆる事態を想定した、徹底的なリスクヘッジ
          </h2>
        </div>

        {/* Intro Text */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <p className="text-xl text-gray-300 leading-relaxed mb-6 font-serif">
            「うまい話には裏があるのではないか？」
          </p>
          <p className="text-lg text-gray-300 leading-relaxed mb-6 font-serif">
            そう思われるのは、投資家として正しい感覚です。
          </p>
          <p className="text-lg text-gray-300 leading-relaxed font-serif">
            だからこそ、私たちは個人の「信用(約束)」に頼るのではなく、車両という<span className="text-[#D4AF37] font-bold text-xl">「現物資産」</span>を<span className="text-[#D4AF37] font-bold text-xl">物理的・法的に徹底管理</span>する独自のシステムを構築しました。
          </p>
        </div>

        {/* Risk Cards */}
        <div className="grid md:grid-cols-3 gap-10">
          {risks.map((risk, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300"
            >
              {/* Number Badge */}
              <div className="flex items-center justify-center mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37] rounded-full flex-shrink-0">
                  <span className="text-white text-2xl font-black font-serif">{risk.number}</span>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-white leading-tight mb-4 text-center font-serif">
                {risk.title}
              </h3>

              {/* Description */}
              <p className="text-base text-gray-300 leading-relaxed font-serif">
                {risk.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-[#D4AF37]/20 border-2 border-[#D4AF37] rounded-2xl px-8 py-6">
            <p className="text-xl font-bold text-[#D4AF37] font-serif">
              リスクを最小化し、安定した収益を実現する仕組みがここにあります
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
